import * as actionTypes from './actionTypes';

export const updateAgentBalance=(data)=>{
   return {
      type:actionTypes.UPDATE_AGENT_BALANCE,
      payload:data
   }
}